import { useEffect, useRef } from "react";

export default function useForwardedRef<T>(forwardRef: React.ForwardedRef<T>) {

    const innerRef = useRef<T | null>(forwardRef === null || typeof forwardRef === 'function' ? null : forwardRef?.current);

    useEffect(() => {
        if (!forwardRef) return;
        if (typeof forwardRef === 'function') {
            forwardRef(innerRef.current);
        } else {
            forwardRef.current = innerRef.current;
        }
    }, [forwardRef]);

    return innerRef;
}